import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";
import classNames from "classnames";

import makeStyles from "@mui/styles/makeStyles";

import PrintButton from "./PrintButton";
import DownloadShipmentFile from "./DownloadShipmentFile";

import {lighterBlack} from "assets/jss/main";

const useStyle = makeStyles({
    title: {
        fontSize: '16px',
        color: lighterBlack,
        fontWeight: 400,
        display: 'flex',
        letterSpacing: '0.192px',
    },
    number: {
        color: lighterBlack,
        fontWeight: 'bold',
        '&:visited': {
            color: lighterBlack,
        }
    },
    numberUnderline: {
        textDecoration: 'underline',
    },
    emptySpace: {
        width: '24px',
        height: '24px'
    }
});

TrackingNumberItem.propTypes = {
    trackingNumber: PropTypes.string,
    document: PropTypes.object,
    documentUrl: PropTypes.string,
    trackingUrl: PropTypes.string,
    currentOrganization: PropTypes.object,
    type: PropTypes.string,
};

function TrackingNumberItem({
    trackingNumber,
    document = null,
    documentUrl = null,
    trackingUrl = null,
    currentOrganization,
    type = 'send',
    index = null
}) {
    const classes = useStyle();

    return (
        <span className={classes.title}>
            <FormattedMessage id={`picking.order.shipments.header.trackingNumber.${type}`}/>{index !== null ? ` n°${index}` : ''}&nbsp;:&nbsp;
            {document ? (
                <>
                    <a
                        href={trackingUrl ?? documentUrl}
                        className={classNames(classes.number, classes.numberUnderline)}
                        target={trackingUrl ? '_blank' : '_self'}
                        rel="noreferrer"
                    >
                        {trackingNumber}
                    </a>
                    <DownloadShipmentFile shipmentLabelLink={documentUrl}/>
                    {currentOrganization.printNodeKey &&
                        <PrintButton shipmentDocument={document} currentOrganization={currentOrganization}/>
                    }
                </>
            ) : trackingUrl ? (
                <a
                    href={trackingUrl}
                    className={classNames(classes.number, classes.numberUnderline)}
                    target={'_blank'}
                    rel="noreferrer"
                >
                    {trackingNumber}
                </a>
            ) : (
                <>
                    <span className={classes.number}>{trackingNumber}</span>
                    <div className={classes.emptySpace}></div>
                </>
            )}
        </span>
    );
}

export default TrackingNumberItem;
